// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eruda-dev-tools .eruda-tools .eruda-monitor{padding:10px}.eruda-dev-tools .eruda-tools .eruda-monitor .eruda-memory{margin:10px 0}\n", ""]);
// Exports
module.exports = exports;
